import {ApiError, isAbortError, isApiError} from './ApiError'
import {addBreadcrumb} from './breadcrumb'
import {reportError} from './reportError'

// customFetch synthesizes "Request failed: 500" when the response has no parseable body.
// Such strings are technical noise — callers should fall back to a localized message.
const SYNTHETIC_MESSAGE = /^Request failed: \d+$/

/**
 * Inspect an error from a customFetch call and decide how to report it.
 *
 * Returns a user-facing message string ONLY when the backend supplied a meaningful
 * one (typically 4xx validation errors). For network failures, 5xx, or synthesized
 * "Request failed: N" placeholders it returns undefined so the caller shows a
 * friendly action-specific fallback (e.g. "Couldn't delete the project").
 */
export const handleApiError = (err: unknown, context: string): string | undefined => {
  if (isAbortError(err)) return undefined

  if (isApiError(err)) {
    const {status, message} = err
    if (status === 0) {
      addBreadcrumb('api', `${context} - network`, 'warning', {url: err.url})
      return undefined
    }
    if (status >= 500) {
      addBreadcrumb('api', `${context} - ${status}`, 'error', {url: err.url, message})
      return undefined
    }
    addBreadcrumb('api', `${context} - ${status}`, 'warning', {url: err.url, message})
    if (SYNTHETIC_MESSAGE.test(message)) return undefined
    return message
  }

  reportError(err, `${context} - unexpected`)
  return undefined
}

export {ApiError}
